<template>
  <IQOS required>
    <div class="logo-row">
      <img
        :src="edit_fields.image || '/icons/cafe-logo-placeholder.png'"
        class="logo-image"
      />
      <div class="logo-info ml-16">
        <div class="logo-header">
          <span class="qrw-heading-xs"> {{ $t('image_uploader.type_logo') }} </span>
          <IQOSImageActions v-model="edit_fields.image" @change="save" />
        </div>
        <BaseDivider color="v1-grey-4" class="mt-8"/>
        <div class="qrw-label-sm mt-8">
          <span class="iqos-comment">
            {{ $t('image_uploader.size') }}
          </span>
          2x1
        </div>
        <div class="qrw-label-sm mt-8">
          <span class="iqos-comment">
            {{ $t('image_uploader.format') }}
          </span>
          JPEG, PNG, WEBP, TIFF, SVG
        </div>
      </div>
    </div>
    <BaseDivider color="v1-grey-6" class="mt-16" v-if="!is_chain"/>
    <div class="logo-row mt-16" v-if="!is_chain">
      <img
        :src="cafe.image_bg || '/icons/cafe-logo-placeholder.png'"
        class="logo-image"
      />
      <div class="logo-info ml-16">
        <div class="logo-header">
          <span class="qrw-heading-xs"> 
            {{ $t('image_uploader.type_cover') }} </span>
          <IQOSImageActions defaultSize="lg" v-model="edit_fields.image_bg" @change="save"/>
        </div>
        <BaseDivider color="v1-grey-4" class="mt-8"/>
        <div class="qrw-label-sm mt-8">
          <span class="iqos-comment">
            {{ $t('image_uploader.size') }}
          </span>
          4x1
        </div>
        <div class="qrw-label-sm mt-8">
          <span class="iqos-comment">
            {{ $t('image_uploader.format') }}
          </span>
          JPEG, PNG, WEBP, TIFF, SVG
        </div>
      </div>
    </div>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      edit_fields: {
        image: null,
        image_bg: null,
      },
    };
  },
  props: {
    is_chain: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    save() {
      if (this.is_chain) {
        this.$store.commit("setChainData", {
          key: 'logo',
          value: this.edit_fields.image
        });
        this.$store.dispatch("saveChain");
      } else {
        this.$store.commit("patchCafeGeneralData", this.edit_fields);
        this.$store.dispatch("saveCafe");
      }
      
    },
  },
  mounted() {
    if (this.is_chain) {
      this.edit_fields.image = this.chain.logo;
    } else {
      this.edit_fields.image = this.cafe.image;
      this.edit_fields.image_bg = this.cafe.image_bg;
    }
    
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    chain() {
      return this.$store.state.selected_chain;
    }
  },
};
</script>

<style scoped>
.logo-image {
  max-width: 178px;
  width: 178px;
  min-width: 178px;
  object-fit: cover;
  border-radius: 4px;
  height: 89px;
  max-height: 89px;
  min-height: 89px;
}

.logo-row {
  display: flex;
}

.logo-info {
  width: 100%;
}

.logo-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.logo-buttons {
  display: flex;
}
</style>